// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RbK88","colBig":"styles_colBig__2YKwE","colSmall":"styles_colSmall__2BqGW"};